/**
 * ShareModal — the share sheet for a published event: big QR code (scan to open
 * on a phone — ideal for printing / table tents at the venue), the copyable
 * link, and an open-in-new-tab action.
 */
import React, { useState } from 'react';
import Modal from './Modal';
import { shareLink } from '../eventUtils';

export default function ShareModal({ open, onClose, eventId, title }) {
  const [copied, setCopied] = useState(false);
  if (!eventId) return null;

  const link = shareLink(eventId);
  const qr = `https://api.qrserver.com/v1/create-qr-code/?size=240x240&margin=10&data=${encodeURIComponent(link)}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch { /* clipboard blocked */ }
  };

  return (
    <Modal open={open} onClose={onClose} title="Share pre-order link">
      <div className="ev-share">
        <p className="ev-share__sub">
          Anyone with this link can pre-order for <strong>{title || 'this event'}</strong>.
        </p>
        <div className="ev-share__qr">
          <img
            src={qr}
            alt="QR code that opens the pre-order form"
            width={200}
            height={200}
            onError={(e) => { e.currentTarget.parentElement.style.display = 'none'; }}
          />
          <span>Scan to open on a phone</span>
        </div>
        <div className="ev-share__linkrow">
          <input className="ev-input" readOnly value={link} onFocus={(e) => e.target.select()} />
          <button className="ev__btn ev__btn--primary" onClick={copy}>{copied ? 'Copied!' : 'Copy'}</button>
        </div>
        <a className="ev__btn ev-share__open" href={link} target="_blank" rel="noopener noreferrer">
          Open form ↗
        </a>
      </div>
    </Modal>
  );
}
